import { c as _c } from "react/compiler-runtime";
import { Image } from "@opensea/next-ui-kit";
import { classNames, UnstyledButton } from "@opensea/ui-kit";
import ReactHlsPlayer from "react-hls-video-player";
export function PreviewImageThumbnail(t0) {
  const $ = _c(16);
  const {
    image,
    isSelected,
    onClick
  } = t0;
  let t1;
  if ($[0] !== image.__typename || $[1] !== image.imageUrl || $[2] !== image.mediaType || $[3] !== image.muxPlaybackId || $[4] !== image.thumbnailUrl || $[5] !== image.url || $[6] !== image.videoUrl) {
    t1 = function renderThumbnailContent() {
      const _mediaType = image.__typename || image.mediaType;
      switch (_mediaType) {
        case "ImageMedia":
          {}
        case "IMAGE":
          {
            return <Image alt="Preview thumbnail" className="h-full w-full object-cover" height={1000} src={image.imageUrl || image.url || ""} width={1000} />;
          }
        case "MuxVideoMedia":
          {}
        case "MUX_VIDEO":
          {
            if (image.thumbnailUrl) {
              return <Image alt="Video thumbnail" className="h-full w-full object-cover" height={1000} src={image.thumbnailUrl} width={1000} />;
            }
            return <ReactHlsPlayer className="h-full w-full object-cover" controls={false} loop={true} muted={true} playsInline={true} src={`https://stream.mux.com/${image.muxPlaybackId}.m3u8`} />;
          }
        case "VideoMedia":
          {}
        case "VIDEO":
          {
            if (image.thumbnailUrl) {
              return <Image alt="Video thumbnail" className="h-full w-full object-cover" height={1000} src={image.thumbnailUrl} width={1000} />;
            }
            return <video className="h-full w-full object-cover" muted={true} playsInline={true} src={image.videoUrl || image.url || ""} />;
          }
        default:
          {
            const _fallbackUrl = image.url || image.imageUrl || image.videoUrl;
            if (_fallbackUrl) {
              return <Image alt="Preview thumbnail" className="h-full w-full object-cover" height={1000} src={_fallbackUrl} width={1000} />;
            }
            return <div className="flex h-full w-full items-center justify-center bg-bg-additional-2"><span className="text-sm text-text-secondary">No preview</span></div>;
          }
      }
    };
    $[0] = image.__typename;
    $[1] = image.imageUrl;
    $[2] = image.mediaType;
    $[3] = image.muxPlaybackId;
    $[4] = image.thumbnailUrl;
    $[5] = image.url;
    $[6] = image.videoUrl;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const renderThumbnailContent = t1;
  const t2 = isSelected ? "ring-2 ring-accent ring-offset-2" : "hover:ring-1 hover:ring-border-3";
  let t3;
  if ($[8] !== t2) {
    t3 = classNames("aspect-square w-full overflow-hidden rounded-lg", "cursor-pointer transition-all duration-200", t2);
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== renderThumbnailContent) {
    t4 = renderThumbnailContent();
    $[10] = renderThumbnailContent;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onClick || $[13] !== t3 || $[14] !== t4) {
    t5 = <UnstyledButton className={t3} onClick={onClick}>{t4}</UnstyledButton>;
    $[12] = onClick;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}